import {EquipmentPlain} from '@hconnect/common/types'
import moment from 'moment-timezone'

import {OilAnalysisActionDto, TaskSource} from '../types'
import {
  EditOilAnalysisAction,
  EditOilAnalysisActionDto,
  OilAnalysisActionFormValues
} from '../types/oil-analysis-actions.types'

export const mapToOilAnalysisActionFormValues = (
  data: OilAnalysisActionDto,
  timezone: string
): OilAnalysisActionFormValues => {
  return {
    ...data,
    dueDate: data.dueDate ? moment.tz(data.dueDate, timezone).toISOString() : null,
    ...(data.assignees && {
      assignees: data.assignees
    }),
    source: TaskSource.OIL_ANALYSIS_ACTIONS,
    functionalLocation: data.oilAnalysisProperties?.functionalLocation ?? null,
    processStage: data.processStage,
    ...(data.equipment && {
      equipment: {
        equipment: data.equipment,
        ...(data.processStage && {processStage: {processStep: data.processStage}}),
        ...(data.mainEquipment && {mainEquipment: data.mainEquipment})
      } as EquipmentPlain
    })
  }
}

const mapToEditOilAnalysisActionDto = (
  formValues: OilAnalysisActionFormValues
): EditOilAnalysisActionDto => {
  const {assignees, mainEquipment, equipment, dueDate, ...rest} = formValues
  return {
    ...rest,
    equipmentId: equipment?.equipment.id,
    equipmentIdType: equipment?.equipment.idType,
    equipmentText: equipment?.equipment.text,
    mainEquipmentId: mainEquipment?.id,
    mainEquipmentIdType: mainEquipment?.idType,
    mainEquipmentText: mainEquipment?.text,
    dueDate: dueDate ?? '', // Validation ensures dueDate is required before submission
    assignees: assignees.map((assignee) => assignee.id)
  }
}

export const mapToOilAnalysisAction = (
  formValues: OilAnalysisActionFormValues,
  id: string,
  plantUpmId: string
): EditOilAnalysisAction => {
  return {
    ...mapToEditOilAnalysisActionDto(formValues),
    id,
    plantUpmId
  }
}
